import { render } from "./Btn.vue?vue&type=template&id=b6cc9e94&scoped=true"
import script from "./Btn.vue?vue&type=script&lang=js"
export * from "./Btn.vue?vue&type=script&lang=js"

import "./Btn.vue?vue&type=style&index=0&id=b6cc9e94&scoped=true&lang=css"

import exportComponent from "/Users/williamconnell/Desktop/Minilogue Project/xdpatch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6cc9e94"]])

export default __exports__